import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import ImageLoader from '../../images/ImageLoader';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { Button } from 'react-bootstrap';
import { Field, Form, Formik } from 'formik';
import OrderNumberField from './OrderNumberField';
import { useFlags } from 'launchdarkly-react-client-sdk';

var InStoreReceipt = function InStoreReceipt(props) {
  var _model$MobileCopy, _model$Copy, _model$ScanBarcodeCTA;

  var model = props.model;
  var formikRef = useRef();
  var flags = useFlags();
  var showReceiptScanTool = flags['showReceiptScanTool'] ? flags['showReceiptScanTool'] : false;

  var handleScanButtonClick = function handleScanButtonClick() {
    props.setShowReceiptScanModal(true);
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showScanTool = _useState2[0],
      setShowScanTool = _useState2[1];
  /**
   * Function to show or hide scan tool based on a feature flag and the screen size
   */


  var showOrHideDesktopScan = function showOrHideDesktopScan() {
    if (window.innerWidth <= 1024 && showReceiptScanTool) {
      setShowScanTool(true);
    } else {
      setShowScanTool(false);
    }
  }; // Update viewport height to fix scroll on mobile devices


  useEffect(function () {
    showOrHideDesktopScan();
    window.addEventListener('resize', showOrHideDesktopScan);
    return function () {
      window.removeEventListener('resize', showOrHideDesktopScan);
    };
  }, [showReceiptScanTool]);
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-in-store-miss-credit"
  }, showScanTool && /*#__PURE__*/React.createElement("div", {
    className: "cb-in-store-miss-credit__header"
  }, (model === null || model === void 0 ? void 0 : (_model$MobileCopy = model.MobileCopy) === null || _model$MobileCopy === void 0 ? void 0 : _model$MobileCopy.value) || ''), /*#__PURE__*/React.createElement("div", {
    className: "cb-in-store-miss-credit__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-in-store-miss-credit__logo-image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: model === null || model === void 0 ? void 0 : model.Image,
    type: 'product',
    className: "cb-in-store-miss-credit__logo-image"
  })), showScanTool && /*#__PURE__*/React.createElement("div", {
    className: 'cb-in-store-miss-credit__scan-barcode-copy'
  }, ((_model$Copy = model.Copy) === null || _model$Copy === void 0 ? void 0 : _model$Copy.value) || ''), showScanTool && /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary cb-in-store-miss-credit__scan-barcode-button",
    onClick: handleScanButtonClick
  }, ((_model$ScanBarcodeCTA = model.ScanBarcodeCTA) === null || _model$ScanBarcodeCTA === void 0 ? void 0 : _model$ScanBarcodeCTA.value) || ''), showScanTool && /*#__PURE__*/React.createElement("div", {
    className: 'cb-in-store-miss-credit__separator'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-in-store-miss-credit__separator__line'
  }), /*#__PURE__*/React.createElement("div", {
    className: 'cb-in-store-miss-credit__separator__text'
  }, "Or"), /*#__PURE__*/React.createElement("div", {
    className: 'cb-in-store-miss-credit__separator__line'
  })), /*#__PURE__*/React.createElement(RichText, {
    className: "cb-in-store-miss-credit__order-number-copy ".concat(!showScanTool ? 'cb-in-store-miss-credit__order-number-copy--no-scan' : ''),
    field: model.OrderNumberCopy
  }), /*#__PURE__*/React.createElement(Formik, {
    innerRef: formikRef,
    initialValues: {
      orderNumber: ''
    },
    validateOnMount: true,
    validate: function validate(values) {
      var errors = {};

      if (!values.orderNumber || !/^\d{17}$/i.test(values.orderNumber)) {
        var _model$ErrorMessage;

        errors.orderNumber = ((_model$ErrorMessage = model.ErrorMessage) === null || _model$ErrorMessage === void 0 ? void 0 : _model$ErrorMessage.value) || '';
      }

      return errors;
    },
    onSubmit: function onSubmit(values, _ref) {
      var setSubmitting = _ref.setSubmitting;
      props.handleSubmitOrderNumber(values.orderNumber, 'inStore', formikRef).then(function () {
        setSubmitting(false);
      });
    }
  }, function (_ref2) {
    var _model$HintText, _model$TitleCTA;

    var isSubmitting = _ref2.isSubmitting,
        isValid = _ref2.isValid,
        values = _ref2.values;
    return /*#__PURE__*/React.createElement(Form, {
      className: "cb-in-store-miss-credit__order-number-form"
    }, /*#__PURE__*/React.createElement(Field, {
      type: "digits",
      maxLength: 17,
      name: "orderNumber",
      className: "cb-form__input--full cb-in-store-miss-credit__order-number",
      label: ((_model$HintText = model.HintText) === null || _model$HintText === void 0 ? void 0 : _model$HintText.value) || '',
      component: OrderNumberField,
      changeHandler: function changeHandler() {},
      value: values.orderNumber
    }), /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      disabled: isSubmitting || !isValid,
      className: "cb-button-primary loyalty--sign-in-form__submit"
    }, ((_model$TitleCTA = model.TitleCTA) === null || _model$TitleCTA === void 0 ? void 0 : _model$TitleCTA.value) || ''));
  })), /*#__PURE__*/React.createElement(RichText, {
    className: "cb-in-store-miss-credit__disclaimer",
    field: model === null || model === void 0 ? void 0 : model.Disclaimer
  }));
};

export default InStoreReceipt;